import { Trans, useTranslation } from 'react-i18next';

import { env } from '@/env';

export function EnvUnsupported() {
  const { t } = useTranslation('general', { useSuspense: false });
  const bot = env.telegramBotUsername;
  const directLink = `https://t.me/${bot}`;
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-6 text-center">
      <h1 className="text-3xl font-bold text-brand">QLASH</h1>
      <p className="max-w-sm text-sm text-fg-muted">
        {t('envUnsupported.body')}
      </p>
      <a
        href={directLink}
        className="rounded-md bg-brand px-6 py-3 text-base font-bold text-brand-fg transition-opacity active:opacity-80"
      >
        {t('envUnsupported.open', { bot })}
      </a>
      <p className="max-w-sm text-xs text-fg-muted">
        <Trans t={t} i18nKey="envUnsupported.hint" components={{ strong: <strong /> }} />
      </p>
    </div>
  );
}
